module.exports = __webpack_public_path__ + "img/web_01.f4f55e78.png";